module.exports = __webpack_public_path__ + "static/media/JustinStaples.c9239af0.jpg";